import BaseResource from '@sigmacloud/sigma-client/dist/resources'

// {{url}}/reports/employee_check_stub_history/raw?payroll=3901&employee=2111&force=true&jwt={{auth}}
export default class ReportCheckStubHistoryResource extends BaseResource {
  static endpoint = '/reports/employee_check_stub_history/raw'
  static modelName = 'reportCheckStubHistory'
}



// WEBPACK FOOTER //
// ./src/resources/ReportCheckStubHistoryResource.js